import React from 'react';
import { useLocaleContext } from '../../../utils/LangContext';
import styled from 'styled-components';
import Link from 'next/link';
import { P } from '../../../components/shared/Dangerously';
import FooterNav from './FooterNav';
import { Fade } from 'react-awesome-reveal';
import TitleSectionGrid from '../../../components/shared/TitleSectionGrid';
import FooterLogoCrop from './FooterLogoCrop';
import { Button } from '../../../components/ui/Button/Button';
import { WEB_DISCOVERY_URL } from '../../../utils/constants';
import * as FacebookPixel from '../../../utils/facebookPixel';

interface ContactFooterProps {
  trackScheduleClick?: boolean;
}

const ContactFooter = ({ trackScheduleClick = false }: ContactFooterProps) => {
  const context = useLocaleContext();
  const { title, p, button_text } = context.contact_footer;

  const handleScheduleClick = () => {
    if (!trackScheduleClick) return;
    FacebookPixel.trackSchedule({ contentName: button_text });
  };

  return (
    <footer>
      <Grid>
        <Fade triggerOnce>
          <P className="h1 text-white">{title}</P>
        </Fade>
        <Fade triggerOnce>
          <p>{p}</p>
          <Link
            href={WEB_DISCOVERY_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleScheduleClick}
          >
            <Button text={button_text} variant="secondary" />
          </Link>
        </Fade>
        <FooterLogoCrop />
      </Grid>
      <FooterNav />
    </footer>
  );
};

export default React.memo(ContactFooter);

const Grid = styled(TitleSectionGrid)`
  background-color: ${(props) => props.theme.colors.accent} !important;
  box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
  padding: 10% 4% 20% 4%;
  .h1 {
    color: ${(props) => props.theme.colors.foreground};
  }
  & > div {
    z-index: 8;
  }
  p {
    z-index: 8;
    max-width: 375px;
    color: ${(props) => props.theme.colors.foreground_low};
    margin-bottom: 10px;
    &:hover {
      b {
        border-bottom: ${(props) =>
          props.theme.stroke + ' solid ' + props.theme.colors.background};
        border-color: transparent;
        transition: 0.3s ease all;
      }
    }
    b {
      cursor: pointer;
      position: relative;
      color: ${(props) => props.theme.colors.foreground};
      font-weight: 100;
      transition: 0.3s ease all 0.1s;
      padding-bottom: 2px;
      border-bottom: ${(props) =>
        props.theme.stroke + ' solid ' + props.theme.colors.foreground};
    }
  }
  @media (max-width: 600px) {
    > div:nth-of-type(3) {
      margin-bottom: 20%;
    }
    p {
      max-width: 360px;
      padding-bottom: 5%;
    }
  }
  @media (max-width: 450px) {
    p {
      max-width: 360px;
    }
  }
`;
